import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import reportWebVitals from './reportWebVitals'
import { store } from './state/store'
import './styles/index.css'
// import { GoogleOAuthProvider } from '@react-oauth/google'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    {/* <GoogleOAuthProvider clientId='209956917472-n03aj1e61oo82tvtvq9nap5pfvt59js6.apps.googleusercontent.com'> */}
    <Provider store={store}>
      <App />
    </Provider>
    {/* </GoogleOAuthProvider> */}
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
